import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Field, reduxForm, InjectedFormProps, formValueSelector } from 'redux-form';
import ReduxFormInput from '../../../shared/components/ReduxFormHandlers/ReduxFormInput';
import PageLoader from '../../../shared/components/Loader/PageLoader';
import { connect } from 'react-redux';
import IState from '../../../core/models/IState';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { validatePassword, validateRequired, validateEmail, validateMaxLength, validateMinLength } from '../../../helpers/validation.helper';
import { FormattedMessage } from 'react-intl';
import { getUserSelector } from '../../../core/selectors/user.selector';

interface IProps {
  id: number;
  isDelete: boolean;
  submitHandler: (data: any) => void;
  onModalClosed: () => void;
  getUserLoading: boolean;
  addUserLoading: boolean;
}

const AddUserForm: React.FC<InjectedFormProps<any, IProps> & IProps> = (props: any) => {

  const validateConfirmPassword = (message: string) => (value: string, allValues: any) => {
    if (value !== "" && value !== allValues.Password)
      return message;
  }

  return (
    <Modal className="add-user-modal device-pop-up" show={true} centered onHide={props.onModalClosed}>
      <Modal.Header closeButton>
        <Modal.Title>
          {props.id === -1 ?
            <FormattedMessage id='User_Title_AddUser' /> :
            <FormattedMessage id='User_Title_EditUser' />}
        </Modal.Title>
        {props.getUserLoading ? <PageLoader /> : null}
      </Modal.Header>



      <form onSubmit={props.handleSubmit((values: any) => props.submitHandler(values))} noValidate>
        <Modal.Body>
          <div className="form-group row">
            <label className="label-style"><FormattedMessage id='User_Label_LoginId' /></label>
            {/* <div className="input-group-prepend">
                  <span className="input-group-text justify-content-center">
                    <i className="fa fa-address-book" aria-hidden="true"></i>
                  </span>
                </div> */}
            <Field
              className="form-control"
              name="UserName"
              component={ReduxFormInput}
              type="email"
              // placeholder="User_Label_UserName"
              min={3}
              max={50}
              //spaceAllowed={false}
              validate={[
                validateRequired("User_Validation_Required_Login_Id"),
                validateEmail("User_Validation_Login_Id_Valid"),
                validateMaxLength(50, 'User_Validation_Login_Id_Max_Char')
              ]}
            />
          </div>

          {/* <div className="form-group row">
            <label className="label-style"><FormattedMessage id='User_Label_Email' /></label>
            <Field
              className="form-control"
              name="Email"
              component={ReduxFormInput}
              type="email"
              // placeholder="User_Label_Email"
              max={30}
              validate={[
                validateRequired("User_Validation_Required_Email"),
                validateEmail("User_Validation_Email_Valid"),
                validateMaxLength(50, 'User_Validation_Email_Max_Char')
              ]}
            />
          </div> */}
          {props.id === -1 &&
            < div className="form-group row checkbox">
              <div className="checkbox-area mt-2">
                <label>
                  <Field name="IsDefaultPassword" component={ReduxFormInput} type="checkbox" />
                  <span className="cr">
                    <i className="cr-icon fas fa-check"></i>
                  </span>
                </label>
                <p><FormattedMessage id='Default_Password' /></p>
              </div>
            </div>
          }

          {props.id === -1 && !props.isDefaultPassword &&
            <div>
              <div className="form-group row">
                <label className="label-style"><FormattedMessage id='User_Label_Password' /></label>
                {/* <div className="input-group-prepend">
                      <span className="input-group-text justify-content-center">
                        <i className="fa fa-home" aria-hidden="true"></i>
                      </span>
                    </div> */}
                <Field
                  className="form-control"
                  name="Password"
                  component={ReduxFormInput}
                  type="password"
                  // placeholder="User_Label_Password"
                  min={6}
                  max={20}
                  validate={[
                    validateRequired("Validation_Required_Password"),
                    validatePassword,
                    validateMinLength(6, 'User_Validation_Password_Min_Char'),
                    validateMaxLength(20, 'User_Validation_Password_Max_Char')]}
                />
              </div>

              <div className="form-group row">
                <label className="label-style"><FormattedMessage id='Label_ConfirmPassword' /></label>
                {/* <div className="input-group-prepend">
                      <span className="input-group-text justify-content-center">
                        <i className="fa fa-home" aria-hidden="true"></i>
                      </span>
                    </div> */}
                <Field
                  className="form-control"
                  name="ConfirmPassword"
                  component={ReduxFormInput}
                  type="password"
                  // placeholder="User_Label_ConfirmPassword"
                  min={6}
                  max={20}
                  validate={[validateRequired("Validation_Required_Confirm_Password"),
                  validateConfirmPassword("Validation_New_Confirm_Password_Mismatch")]}
                />
              </div>
            </div>}

          <div className="form-group row checkbox">
            <div className="checkbox-area mt-2">
              <label>
                <Field name="UserType" component={ReduxFormInput} type="checkbox" />
                <span className="cr">
                  <i className="cr-icon fas fa-check"></i>
                </span>
              </label>
              <p><FormattedMessage id='User_Label_IsAdmin' /></p>
            </div>
          </div>

        </Modal.Body>

        <div className="modal-footer">
          <div className="form-group row tab-action">
            <div className="col-12 p-0">
              <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button>
              <LoaderButton type="submit" isLoading={props.addEmployeeLoading} text={props.id === -1 ? "Button_Save" : "Button_Edit"} />
            </div>
          </div>
        </div>
      </form>


    </Modal >
  )
}

const selector = formValueSelector('AddUserForm');

const mapStateToProps = (state: IState) => ({
  initialValues: getUserSelector(state),
  passwordSelector: selector(state, 'Password'),
  isDefaultPassword: selector(state, 'IsDefaultPassword')
});


const form = reduxForm<any, IProps>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: 'AddUserForm',
  enableReinitialize: true,
  onSubmitFail: (errors: any) => {
    //toast.error(formatMessage('Validation_Correct_error'));
  }
})(AddUserForm);


export default connect(mapStateToProps)(form);
